import { render, staticRenderFns } from "./TaxCreateEditModal.vue?vue&type=template&id=1002b400&"
import script from "./TaxCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./TaxCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports